import React from 'react';

function SelectableImageOption({ option, isSelected, onClick }) {
    const { value, imageSrc, altText, text } = option;

    const handleClick = () => {
        onClick(value);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            onClick(value);
        }
    };

    return (
        <div
            className={`card-option ${isSelected ? 'selected' : ''}`}
            data-value={value}
            onClick={handleClick}
            onKeyPress={handleKeyPress}
            role="button"
            tabIndex={0}
        >
            <img src={imageSrc} className="card-img-top" alt={altText} />
            <div className="card-body">
                <p className="card-text">{text}</p>
            </div>
        </div>
    );
}

export default SelectableImageOption;